import { useRef, useState } from 'react';
import DotsIcon from '../../../../assets/Feed/DotsIcon';
import { HeartIcon, NoHeart } from '../../../../assets/Posts/HeartIcon';
import { api } from '../../../../services/api';
import { timeSinceFormatter } from '../../../../utils/formatter';
import CommentsModal from '../../../Modals/CommentsModal';
import UserIcon from '../../../UserIcon';
import { CommenterName, CommenterNameContainer, LikeCommentContainer, ResponderContainer, ResponderText, RightContainer, SubCommentContainer, SubCommentText, SubMiddleContainer, TimeSinceComment } from '../styles';

type CommentProps = {
  index: number;
  authorAvatarUrl: string;
  authorId: string;
  authorUsername: string;
  publicationUsername: string;
  childs: number;
  feedType: string;
  content: string;
  createdAt: string;
  id: string;
  likes: number;
  parentId: string;
  publicationId: string;
  updatedAt: string;
  handleResponse: (response: string) => void;
  setAnswerTarget: (target: string) => void;
  scrollPosition: number;
  setCommentModalOpen: (open: boolean) => void;
  commentModalOpen: boolean;
  setCommentModalIndex: (index: string) => void;
  commentModalIndex: string;
}

export default function SubComment({
  index,
  authorAvatarUrl,
  authorId,
  authorUsername,
  publicationUsername,
  childs,
  feedType,
  content,
  createdAt,
  id,
  likes,
  parentId,
  publicationId,
  updatedAt,
  handleResponse,
  setAnswerTarget,
  scrollPosition,
  setCommentModalOpen,
  commentModalOpen,
  setCommentModalIndex,
  commentModalIndex
}: CommentProps) {
  const [liked, setLiked] = useState<boolean>();
  const [showOptions, setShowOptions] = useState<boolean>(false);
  const [likesCount, setLikesCount] = useState(likes)

  const handleAnswer = () => {
    handleResponse('@' + authorUsername + ' ')
    setAnswerTarget(parentId)
  }

  const handleLike = async () => {
    setLiked(!liked);
    if (!liked) {
      setLikesCount(likesCount + 1)
    } else {
      setLikesCount(likesCount - 1)
    }
    try {
      const response = await api.post(`/comments/like/${id}`)
      if (response.status !== 200 && !liked) {
        setLiked(!liked)
        setLikesCount(likesCount - 1)
      }
    } catch (error) {
      console.log(error)
    }
  }

  const commentRef = useRef<any>(null);
  const [SubCommentOffsetModal, setSubCommentOffsetModal] = useState<number>(0);

  const handleIconClick = () => {
    if (commentRef.current) {
      const rect = commentRef.current.getBoundingClientRect();
      if (scrollPosition === 0) {
        const value = 20
        setSubCommentOffsetModal(value);
      } else {
        const value = - scrollPosition + 20;
        setSubCommentOffsetModal(value);
      }
      if (!commentModalOpen || commentModalIndex === id) {
        setShowOptions(!showOptions);
        setCommentModalOpen(!commentModalOpen);
        setCommentModalIndex(id);
      }
    }
  };


  return (
    <SubCommentContainer>
      <div style={{ width: '100%' }}>
        <UserIcon size='s' icon={authorAvatarUrl} />
      </div>
      <SubMiddleContainer>
        <CommenterNameContainer>
          <CommenterName>
            {authorUsername}
          </CommenterName>
          <TimeSinceComment>{timeSinceFormatter(createdAt)}</TimeSinceComment>
        </CommenterNameContainer>
        <SubCommentText>
          {content}
        </SubCommentText>
        <ResponderContainer>
          <ResponderText
            style={{ cursor: 'pointer' }}
            onClick={() => handleAnswer()}
          >
            Responder
          </ResponderText>
          <LikeCommentContainer onClick={() => handleLike()}>
            {liked ? <HeartIcon /> : <NoHeart />}
            <ResponderText>{likesCount}</ResponderText>
          </LikeCommentContainer>
        </ResponderContainer>
      </SubMiddleContainer>
      <CommentsModal
        feedType={feedType}
        commentId={id}
        onAction={() => setShowOptions(false)}
        authorUsername={authorUsername}
        open={showOptions}
        publicationUsername={publicationUsername}
        scrollY={SubCommentOffsetModal}
      />
      <RightContainer ref={commentRef} onClick={() => handleIconClick()}>
        <DotsIcon />
      </RightContainer>
    </SubCommentContainer>
  )
}